import React, { useState, useEffect } from 'react';

function SessionExpirationModal({ remainingSeconds, onContinue, onDismiss }) {
  const [countdown, setCountdown] = useState(remainingSeconds);
  const [isExtending, setIsExtending] = useState(false);

  useEffect(() => {
    setCountdown(remainingSeconds);
  }, [remainingSeconds]);

  useEffect(() => {
    if (countdown <= 0) {
      return;
    }
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  const handleContinue = async () => {
    setIsExtending(true);
    try {
      await onContinue();
    } catch (error) {
    } finally {
      setIsExtending(false);
    }
  };

  const isExpired = countdown <= 0;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        <div className="text-center mb-6">
          <div className={`inline-flex items-center justify-center w-16 h-16 ${isExpired ? 'bg-red-100' : 'bg-yellow-100'} rounded-full mb-4`}>
            <svg
              className={`w-8 h-8 ${isExpired ? 'text-red-600' : 'text-yellow-600'}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            {isExpired ? 'Session Expired' : 'Session Expiring Soon'}
          </h2>
          <p className="text-gray-600 mb-4">
            {isExpired ? (
              <>Your session has expired.</>
            ) : (
              <>
                Your session will expire in{' '}
                <span className="font-bold text-red-600">{countdown}</span> second
                {countdown !== 1 ? 's' : ''}.
              </>
            )}
          </p>
          <p className="text-sm text-gray-500 mb-6">
            {isExpired
              ? 'Click "Continue" to refresh your session, or "Sign Out" to log out.'
              : 'Click "Continue" to keep your session active.'}
          </p>
        </div>

        <div className="flex gap-4">
          <button
            onClick={onDismiss}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
          >
            {isExpired ? 'Sign Out' : 'Dismiss'}
          </button>
          <button
            onClick={handleContinue}
            disabled={isExtending}
            className={`flex-1 px-4 py-2 rounded-md text-white font-medium transition-colors ${
              isExtending
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {isExtending ? 'Extending...' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionExpirationModal;

